import api from "../api";
import {getSubdomain} from "../../utils/general";
import {updateSiteStyleVariables} from "../../utils/subdomains/configHandlers";


export const pullSubdomainConfig = () => {
    let subdomain = getSubdomain();
    if (!subdomain) subdomain = '__DEFAULT__'
    return api.get(`/subdomain-configs/${subdomain}/`)
        .then(res =>{
            const config = res.data?.config || {}
            updateSiteStyleVariables(config)
            console.log(res.data)
            return {
                ...config,
                subdomain_description: res.data.description,
                subdomain // : subdomain === '__DEFAULT__' ? 'CleanFi' : subdomain
            }
        } )
}

